import { delay, put, takeEvery } from "redux-saga/effects";
import { setToast } from "./globalActionSlice";

function*   handleToastOpen(action: any) {
    yield put(setToast(action.payload));
    yield delay(10000);

    yield put(setToast(undefined));
}
function*   handleToastClose(action: any) {
    yield put(setToast(undefined));
}
export function* globalActionSaga() {
    yield takeEvery("GLOBAL_TOAST_OPEN", handleToastOpen);
    yield takeEvery("GLOBAL_TOAST_CLOSE", handleToastClose);
}